export const AUDIO_PROCESSING_KEYS = {
  USAGE_REPORT: 'audio_processing.usage_report',
};
